import { createAction, props } from '@ngrx/store';

export const loadBasketRaffleList = createAction(
  '[BasketRaffle] Load Basket Raffle Item List',
  props<any>()
);

export const loadBasketRaffleListSuccess = createAction(
  '[BasketRaffle] Load Basket Raffle Item List Success',
  props<any>()
);

export const loadBasketRaffleListFailure = createAction(
  '[BasketRaffle] Load Basket Raffle Item List Failure',
  props<any>()
);

export const createBasketRaffleItem = createAction(
  '[BasketRaffle] Create Basket Raffle Item',
  props<any>()
);

export const createBasketRaffleItemSuccess = createAction(
  '[BasketRaffle] Create Basket Raffle Item Success',
  props<any>()
);

export const createBasketRaffleItemFailure = createAction(
  '[BasketRaffle] Create Basket Raffle Item Failure',
  props<any>()
);

export const updateBasketRaffleItem = createAction(
  '[BasketRaffle] Update Basket Raffle Item',
  props<any>()
);

export const updateBasketRaffleItemSuccess = createAction(
  '[BasketRaffle] Update Basket Raffle Item Success',
  props<any>()
);

export const updateBasketRaffleItemFailure = createAction(
  '[BasketRaffle] Update Basket Raffle Item Failure',
  props<any>()
);

export const updateBasketRaffleList = createAction(
  '[BasketRaffle] Update Basket Raffle Item List',
  props<any>()
);

export const updateBasketRaffleListSuccess = createAction(
  '[BasketRaffle] Update Basket Raffle Item List Success',
  props<any>()
);

export const updateBasketRaffleListFailure = createAction(
  '[BasketRaffle] Update Basket Raffle Item List Failure',
  props<any>()
);

export const deleteBasketRaffleItems = createAction(
  '[BasketRaffle] Delete Basket Raffle Items',
  props<any>()
);
  
export const deleteBasketRaffleItemsSuccess = createAction(
  '[BasketRaffle] Delete Basket Raffle Items Success',
  props<any>()
);
  
export const deleteBasketRaffleItemsFailure = createAction(
  '[BasketRaffle] Delete Basket Raffle Items Failure',
  props<any>()
);
  
export const resetBasketRaffleItemList = createAction(
  '[BasketRaffle] Reset Basket Raffle Item List',
  props<any>()
);